export var HTMLCanvasElement = Object;